import { DEFAULT_CHART_PROPERTIES, } from '../client-state-type';
import { ChartResponsiveLayout, ChartVizPropVersion, } from '../types/prism';
import { setAxisProperties } from './chart-reuse-axis';
export const CHART_CLIENT_STATE_LATEST_VERSION = ChartVizPropVersion.V4Dot2;
export const RESPONSIVE_LAYOUT_PREFERENCE_TOGGLE_MAP = {
    [ChartResponsiveLayout.UserPreferredOn]: ChartResponsiveLayout.UserPreferredOff,
    [ChartResponsiveLayout.UserPreferredOff]: ChartResponsiveLayout.UserPreferredOn,
    [ChartResponsiveLayout.AutoOn]: ChartResponsiveLayout.UserPreferredOff,
    [ChartResponsiveLayout.AutoOff]: ChartResponsiveLayout.UserPreferredOn,
};
export const initChartClientState = (vizModel) => {
    var _a;
    return ({
        ...vizModel.vizProps,
        columnProperties: ((_a = vizModel.columns) === null || _a === void 0 ? void 0 : _a.map((col) => {
            return {
                columnId: col.id,
                columnProperty: {
                    __typename: 'ChartVizColumnProperties',
                    conditionalFormatting: null,
                    dataLabels: null,
                    handleMissingValues: null,
                    excludeNullValues: null,
                    customProps: null,
                    kpiColumnProperties: {
                        __typename: 'KpiColumnProperties',
                        showAbbreviatedPreviousDate: null,
                        abbreviatedPreviousDate: null,
                        showSparkline: true,
                        showComparisonDate: true,
                        showCurrentDateLabel: true,
                        showPreviousDateLabel: true,
                        showPreviousValue: true,
                        handleNullData: null,
                    },
                },
            };
        })) || [],
        customColorSelectorArray: [],
        multiColorSeriesColors: [],
        seriesColors: [],
        systemMultiColorSeriesColors: [],
        systemSeriesColors: [],
        chartProperties: DEFAULT_CHART_PROPERTIES,
        axisProperties: setAxisProperties(vizModel),
        tooltipConfig: null,
        version: CHART_CLIENT_STATE_LATEST_VERSION,
        __typename: 'ChartVizProps',
    });
};
//# sourceMappingURL=chart-client-state-init.js.map